import type { LegalHoldStatus } from '../../../../domain/src/lib/legal-hold/legal-hold.model';

export type LegalHoldConfirmActionType = 'close' | 'delete';

export interface LegalHoldPendingConfirm {
  type: LegalHoldConfirmActionType;
  id: string;
  case_name: string;
}

export interface LegalHoldCaseLabelSource {
  case_name?: string;
  case_number?: string;
  id: string;
}

export const LEGAL_HOLD_DELETE_BLOCKED_TOAST = {
  type: 'warning' as const,
  title: 'No se puede eliminar',
  message:
    'El caso está activo. Ciérrelo con el candado abierto y luego podrá eliminarlo.',
  duration: 6000,
};

export function legalHoldCaseDisplayName(row: LegalHoldCaseLabelSource): string {
  return row.case_name || row.case_number || row.id;
}

export function canRequestLegalHoldClose(status: LegalHoldStatus): boolean {
  return status === 'active';
}

export function shouldBlockLegalHoldDelete(status: LegalHoldStatus): boolean {
  return status === 'active';
}

export function buildLegalHoldConfirmDialogTitle(type: LegalHoldConfirmActionType): string {
  return type === 'close' ? 'Cerrar caso' : 'Eliminar caso';
}

export function buildLegalHoldConfirmDialogMessage(pending: LegalHoldPendingConfirm): string {
  if (pending.type === 'close') {
    return `¿Cerrar el caso "${pending.case_name}"? Los documentos en custodia quedarán registrados y el caso pasará a estado cerrado.`;
  }
  return `¿Eliminar permanentemente el caso "${pending.case_name}"? Esta acción no se puede deshacer.`;
}

export function buildLegalHoldConfirmDialogLabel(type: LegalHoldConfirmActionType): string {
  return type === 'close' ? 'Cerrar caso' : 'Eliminar';
}
